<template>
  <div
    class="minimalistic-readiness-level"
    :class="{ disabled: disabled, [levelClass]: true }"
  ></div>
</template>

<script setup>
import { computed } from "vue";
import {
  isBadgeLevelValue,
  normalizeBadgeLevel,
} from "@components/utils/normalizeBadgeLevel";

const props = defineProps({
  level: {
    type: String,
    validator: function (value) {
      return isBadgeLevelValue(value) && normalizeBadgeLevel(value) !== "novice";
    },
    default: "apprentice",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const levelClass = computed(() => normalizeBadgeLevel(props.level) || props.level);
</script>

<style scoped>
.minimalistic-readiness-level {
  width: 24px;
  height: 24px;
  border-radius: 5px;
}

.minimalistic-readiness-level.disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.minimalistic-readiness-level.apprentice {
  border: 1px solid #c17200;
  background: #fff5d3;
}
.minimalistic-readiness-level.proficient {
  border: 1px solid #00b813;
  background: #f3fff9;
}
.minimalistic-readiness-level.coach {
  border: 1px solid #00a3ff;
  background: #effeff;
}
.minimalistic-readiness-level.architect {
  border: 1px solid #2e1ec1;
  background: #f2f3ff;
}
</style>
